import Svg, { Path } from 'react-native-svg';
import { withDefaultIconProps } from './index';

export const ChatBubbles = withDefaultIconProps(
  {
    height: 21,
    width: 26,
  },
  ({ color, ...rest }) => (
    <Svg {...rest} viewBox="0 0 26 21">
      <Path
        d="M6.11 19.93C6.61 19.93 7.05 19.72 7.66 19.19L10.48 16.68C11.13 17.35 12.1 17.71 13.33 17.71H16.33L19.26 20.23C19.84 20.72 20.25 20.99 20.73 20.99C21.43 20.99 21.84 20.49 21.84 19.73V17.71H22.25C24.46 17.71 25.94 16.36 25.94 14.08V8.71C25.94 6.4 24.43 5.01 22.18 5.01H20.65V4.44C20.65 2.05 19.18 0.64 16.77 0.64H3.94C1.6 0.64 0.06 2.05 0.06 4.44V12.67C0.06 15.02 1.57 16.42 3.87 16.42H4.98V18.67C4.98 19.44 5.4 19.93 6.11 19.93ZM6.55 15.56C6.55 15.03 6.22 14.76 5.78 14.76H4.15C2.69 14.76 1.81 13.94 1.81 12.42V4.63C1.81 3.11 2.7 2.29 4.15 2.29H16.55C18.01 2.29 18.89 3.11 18.89 4.63V5.01H13.33C10.99 5.01 9.56 6.4 9.56 8.71V14.08C9.56 14.45 9.6 14.79 9.67 15.1L6.55 18.02V15.56ZM20.28 19.08L17.53 16.59C17.14 16.24 16.81 16.08 16.3 16.08H13.51C12.13 16.08 11.29 15.31 11.29 13.85V8.88C11.29 7.44 12.13 6.66 13.51 6.66H21.98C23.37 6.66 24.21 7.44 24.21 8.88V13.85C24.21 15.3 23.36 16.08 21.98 16.08H21.03C20.6 16.08 20.28 16.34 20.28 16.87V19.08Z"
        fill={color}
      />
    </Svg>
  ),
);

export const ChatBubblesLight = withDefaultIconProps(
  {
    height: 24,
    width: 24,
  },
  ({ color, ...rest }) => (
    <Svg {...rest} viewBox="0 0 24 24">
      <Path
        d="M6.09 20.08C6.52 20.08 6.9 19.9 7.42 19.45L9.84 17.29C10.4 17.87 11.23 18.18 12.28 18.18H14.86L17.36 20.34C17.86 20.76 18.22 20.99 18.62 20.99C19.22 20.99 19.58 20.56 19.58 19.91V18.18H19.93C21.82 18.18 23.09 17.02 23.09 15.07V10.47C23.09 8.49 21.8 7.3 19.86 7.3H18.55V6.81C18.55 4.76 17.3 3.54 15.23 3.54H4.23C2.23 3.54 0.91 4.76 0.91 6.81V13.86C0.91 15.88 2.21 17.08 4.17 17.08H5.12V19C5.12 19.67 5.48 20.08 6.09 20.08ZM6.47 16.34C6.47 15.88 6.19 15.65 5.81 15.65H4.41C3.16 15.65 2.41 14.95 2.41 13.65V6.97C2.41 5.67 3.17 4.96 4.41 4.96H15.04C16.29 4.96 17.05 5.67 17.05 6.97V7.3H12.28C10.27 7.3 9.05 8.49 9.05 10.47V15.07C9.05 15.39 9.08 15.67 9.14 15.95L6.47 18.45V16.34ZM18.24 19.36L15.88 17.22C15.55 16.92 15.27 16.78 14.82 16.78H12.44C11.25 16.78 10.54 16.13 10.54 14.88V10.61C10.54 9.38 11.25 8.71 12.44 8.71H19.7C20.89 8.71 21.61 9.38 21.61 10.61V14.88C21.61 16.12 20.88 16.78 19.7 16.78H18.89C18.52 16.78 18.24 17.01 18.24 17.46V19.36Z"
        fill={color}
      />
    </Svg>
  ),
);
